import { SideNavLink, SideNavMenuItem } from '@metrika/ui-kit/carbon';
import React from 'react';
import { appEnv } from '../_env';
import { riskBasePath } from '../_shared';
import { CarbonNavSubLink, SideNavMenuFixed } from '../layout-v2/components/SidebarMain/components';
import { SidebarMenu } from '../user/types';
import { RiskDiscoverIcon, RiskMonitorIcon, RiskReportsIcon } from './_static/icons/icons';

const getRiskNextUrl = (path: string) => `${appEnv.appDomains.riskNext}/risk/${path}`;

export const RiskDiscoveryMonitorSidebar: React.FC<{
   menu: SidebarMenu;
   urlMatch: (url?: string) => boolean;
   onToggle: () => void;
}> = ({ urlMatch, onToggle }) => {
   return (
      <>
         <SideNavMenuFixed
            key={'discover'}
            title={'Discover'}
            renderIcon={RiskDiscoverIcon}
            defaultExpanded={urlMatch('/risk/kri-catalog')}
         >
            {/* Old v1 KRI Catalog - commented out during v3 migration
            <CarbonNavSubLink
               to={`${riskBasePath}/kri-catalog-v1`}
               onClick={onToggle}
               isActive={urlMatch(`${riskBasePath}/kri-catalog-v1`)}
            >
               KRI Catalog (v1)
            </CarbonNavSubLink>
            */}
            <CarbonNavSubLink
               to={`${riskBasePath}/kri-catalog`}
               onClick={onToggle}
               isActive={urlMatch(`${riskBasePath}/kri-catalog`)}
            >
               KRI Catalog
            </CarbonNavSubLink>
         </SideNavMenuFixed>
         <SideNavMenuFixed
            key={'risk'}
            renderIcon={RiskMonitorIcon}
            title={'Monitor Risk'}
            defaultExpanded={urlMatch(`${riskBasePath}/monitor`) || urlMatch('/risk/frameworks')}
         >
            {/* Old v1 Assessments - commented out during v3 migration
            <CarbonNavSubLink
               to={`${riskBasePath}/monitor-v1`}
               onClick={onToggle}
               isActive={urlMatch(`${riskBasePath}/monitor-v1`)}
            >
               Assessments (v1)
            </CarbonNavSubLink>
            */}
            <SideNavMenuItem as="a" href={getRiskNextUrl('monitors')}>
               Monitors (Beta)
            </SideNavMenuItem>
            <SideNavMenuItem as="a" href={getRiskNextUrl('alerts')}>
               Alerts (Beta)
            </SideNavMenuItem>
            <CarbonNavSubLink
               to={`${riskBasePath}/monitor`}
               onClick={onToggle}
               isActive={urlMatch(`${riskBasePath}/monitor`) && !urlMatch(`${riskBasePath}/monitor-v1`)}
            >
               Assessments
            </CarbonNavSubLink>
            <CarbonNavSubLink
               to={`${riskBasePath}/frameworks`}
               onClick={onToggle}
               isActive={urlMatch(`${riskBasePath}/frameworks`)}
            >
               Frameworks
            </CarbonNavSubLink>
         </SideNavMenuFixed>

         {/* Reports - external link to risk-next.metrika.co (only for Metrika users) */}
         {
            <SideNavLink href={getRiskNextUrl('reports')} renderIcon={RiskReportsIcon}>
               Reports
            </SideNavLink>
         }
      </>
   );
};
